import { VehicleType } from '@evermile/customer-tracking';

export interface Coordinate {
  lat: number;
  lng: number;
}

export interface RouteWayPoint {
  location: Coordinate;
  stopover: boolean;
}

export interface IconLabel {
  text: string;
  className: string;
}

export interface MapMarker {
  id: string;
  coordinate: Coordinate;
  type: MapMarkerType;
  color?: string;
  routeIndex?: number;
  zIndex?: number;
  label?: string;
  width?: number;
  height?: number;
  infoWindowText?: string;
  disableInfoWindowOpenClose?: boolean;
  hoverCustomEvent?: boolean;
  clickCustomEvent?: boolean;
}

export enum MapMarkerType {
  location = 'location',
  pickup = 'pickup',
  dropoff = 'dropoff',
  dropoffSuccess = 'dropoffSuccess',
  routeDropoff = 'routeDropoff',
  car = 'car',
  pushbike = 'pushbike',
  motorbike = 'motorbike',
  cargoBike = 'cargoBike',
  van = 'van',
}

export interface MarkerSettings {
  iconName: string;
  iconNameHover?: string;
  zIndex?: number;
  countable?: boolean;
}

export const londonCenterCoordinates: Coordinate = { lat: 51.50550567565617, lng: -0.12785442591027651 };

export const MapMarkersDefaultSettings: { [key: string]: MarkerSettings } = {
  [MapMarkerType.location]: {
    iconName: 'location',
    zIndex: 1,
  },
  [MapMarkerType.pickup]: {
    iconName: 'pickup',
    zIndex: 1,
  },
  [MapMarkerType.dropoff]: {
    iconName: 'dropoff',
    zIndex: 1,
  },
  [MapMarkerType.dropoffSuccess]: {
    iconName: 'dropoffSuccess',
    zIndex: 1,
  },
  [MapMarkerType.car]: {
    iconName: 'car',
    zIndex: 2,
  },
  [MapMarkerType.pushbike]: {
    iconName: 'pushbike',
    zIndex: 2,
  },
  [MapMarkerType.motorbike]: {
    iconName: 'motorbike',
    zIndex: 2,
  },
  [MapMarkerType.cargoBike]: {
    iconName: 'cargoBike',
    zIndex: 2,
  },
  [MapMarkerType.van]: {
    iconName: 'van',
    zIndex: 2,
  },
};

export const PlatformMapMarkersDefaultSettings: { [key: string]: MarkerSettings } = {
  [MapMarkerType.dropoff]: {
    iconName: 'platform-dropoff',
    iconNameHover: 'platform-dropoff-hover',
    zIndex: 1,
  },
  [MapMarkerType.pickup]: {
    iconName: 'platform-pickup',
    zIndex: 2,
  },
  [MapMarkerType.routeDropoff]: {
    iconName: 'multi-drop-colors/route',
    zIndex: 1,
    countable: true,
  },
};

export const vehicleTypeToTrackingIconType = {
  [VehicleType.Pushbike]: MapMarkerType.pushbike,
  [VehicleType.Motorbike]: MapMarkerType.motorbike,
  [VehicleType.CargoBike]: MapMarkerType.cargoBike,
  [VehicleType.Car]: MapMarkerType.car,
  [VehicleType.SmallVan]: MapMarkerType.van,
  [VehicleType.LargeVan]: MapMarkerType.van,
};

export const RoutesColors = new Map([
  [0, '#637EFF'],
  [1, '#FF987E'],
  [2, '#FFC961'],
  [3, '#48B782'],
  [4, '#FF73B0'],
  [5, '#E470E3'],
  [6, '#15AAEA'],
  [7, '#ED5E5E'],
  [8, '#B5D33A'],
  [9, '#343E57'],
  [10, '#7A89AD'],
]);
